<template>
    <div>

        <b-modal id="change-amount" title="Ödeme Miktarı Düzenleme" no-close-on-esc no-close-on-backdrop>
            <advance-payment-group-key-compare-change-amount v-model="data"></advance-payment-group-key-compare-change-amount>
            <template #modal-footer><v-executer :loading="loading" :action="change" text="Güncelle"></v-executer></template>
        </b-modal>

        <b-modal id="delete-amount" title="Personeli Çıkar" no-close-on-esc no-close-on-backdrop>
            <advance-payment-group-key-compare-delete-amount v-model="data"></advance-payment-group-key-compare-delete-amount>
            <template #modal-footer><v-executer :loading="loading" variant="danger" :action="remove" text="Çıkar" :disabled="!data.Description"></v-executer></template>
        </b-modal>

        

        <v-table    ref="table"
                    :buttons="buttons"
                    :fields="fields"
                    :items-provider="provider"
                    search
                    :row-class="item=>item.TMSAmount != item.BankAmount ? 'bg-light-danger' : null"
                    pagination="server">
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-5">
                                    <select class="form-control" v-model="bank">
                                        <option :value="null">Tümü</option>
                                        <option :value="true">Dosyada Var</option>
                                        <option :value="false">Dosyada Yok</option>
                                    </select>
                                </div>
                                <div class="col-auto">
                                    <button class="btn btn-success" v-on:click="refresh">Sorgula</button>
                                    <v-executer variant="secondary" class="ml-50" v-if="sterling.Sync == false" :action="createFile" :loading="fileCreating">Dosya Oluştur</v-executer>
                                </div>
                            </div>
                        </template>
                    </v-table>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import AdvancePaymentGroupKeyCompareChangeAmount from './AdvancePaymentGroupKeyCompareChangeAmount.vue'
import AdvancePaymentGroupKeyCompareDeleteAmount from './AdvancePaymentGroupKeyCompareDeleteAmount.vue'

export default {
    components:{
        AdvancePaymentGroupKeyCompareChangeAmount,
        AdvancePaymentGroupKeyCompareDeleteAmount
    },
    props:{
        sterling:Object,
        tableRefresh:Function,
        type:String
    },  
    data(){
        return{
            fields:[
                {name:'Personel',key:'FullName',tdClass:'text-nowrap'},
                {name:'Kimlik Numarası',key:'IdentityNumber'},
                {name:'IBAN',key:'IBAN'},
                {name:'TMS Tutarı',key:'TMSAmount'},
                {name:'Dosya Tutarı',key:'BankAmount'},
                {name:'Dosyada Var',key:'Bank',thClass:'text-nowrap'},
            ],
            bank:null,
            data:{
                Id:null,
                NewAmount:null,
                FullName:null,
                Description:null,
            },
            loading:false,
            fileCreating:false
        }
    },
    methods:{
        provider(data){
            // const api = this.type == 'kykm' 
            //     ? EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyListBySterling
            //     : EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyListBySterling
             const api = EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyListBySterling
            return api({
                SterlingId: this.sterling.Id,
                Bank: this.bank,
                ...data
            })
        },
        refresh(){
            this.$refs.table.refresh()
        },
        edit(item){
            this.data.Id = null
            this.data.NewAmount = null
            this.data.FullName = null
            this.data.Description = null
            this.data.Id = item.Id
            this.data.NewAmount = item.TMSAmount
            this.data.FullName = item.FullName
            this.data.Description = item.Description
            this.data.Type = this.type=='kykm' ? 2 : 1
            this.$showModal('change-amount')
        },
        delete(item){
            this.$confirm('Çıkarmak istediğinize emin misiniz?',`Bu işlem ${item.FullName} personelini ödeme listesinden çıkaracaktır ve geri alınamaz.`).then(result=>{
                if(result){
                    this.data.Id = null
                    this.data.NewAmount = null
                    this.data.FullName = null
                    this.data.Description = null
                    this.data.Id = item.Id
                    this.data.NewAmount = item.TMSAmount
                    this.data.FullName = item.FullName
                    this.data.Description = item.Description
                    this.$showModal('delete-amount')
                }
            })
        },
        remove(){
            this.loading = true
            const api = this.type == 'kykm' 
                ? EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyListDelete
                : EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyListRSalaryDelete

            api({
                Id:this.data.Id,
                Description:this.data.Description || ''
            }).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('delete-amount')
                    this.$emit('refresh')
                    this.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        change(){
            this.loading = true
            const api = EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyListChangeAmount

            api(this.data).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('change-amount')
                    this.$emit('refresh')
                    this.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        createFile(){
            this.fileCreating = true
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyGenerate(this.sterling.Id).then(res=>{
                this.fileCreating = false
                this.$result(res)
                if(res.data.Success){
                    this.tableRefresh()
                }
            }).catch(err => {
                this.fileCreating = false
                this.$result(null,err)
            })
        }
    },
    computed:{
        buttons(){
            // Harcırah: tutar yurt içi sürücü maaş ekranının 3. adımında değişir; bu listede salt-okunur.
            if(this.type == 'harcirah') return []
            if(this.sterling.StatusId == 0 || this.sterling.StatusId == 1 || this.sterling.StatusId==12 || this.sterling.StatusId==11){
                return [
                    { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"primary",action:this.edit},
                    { text:"Sil",key:"delete",icon:"MinusCircleIcon",variant:"danger",action:this.delete},
                ]
            }else return []
        }
    }
}
</script>